export const FILTER_STORAGE_KEY = 'almacenes.inventoryDashboard.filters.v1';

export const defaultDateTo = () => new Date().toISOString().slice(0, 10);

export const defaultDateFrom = () => {
  const d = new Date();
  d.setMonth(d.getMonth() - 11);
  d.setDate(1);
  return d.toISOString().slice(0, 10);
};

export const defaultFilters = () => ({
  dateFrom: defaultDateFrom(),
  dateTo: defaultDateTo(),
  warehouseId: '',
});

export const loadStoredFilters = () => {
  try {
    const raw = sessionStorage.getItem(FILTER_STORAGE_KEY);
    if (!raw) return defaultFilters();
    return { ...defaultFilters(), ...JSON.parse(raw) };
  } catch {
    return defaultFilters();
  }
};

export const saveStoredFilters = (filters) => {
  try {
    sessionStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(filters));
  } catch {
    /* ignore */
  }
};

export const buildFilterParams = (filters) => {
  const params = {
    date_from: filters.dateFrom,
    date_to: filters.dateTo,
  };
  if (filters.warehouseId) params.warehouse_id = filters.warehouseId;
  return params;
};

export const formatMoney = (n) => {
  if (n == null || n === '') return '—';
  return `S/ ${(parseFloat(n) || 0).toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const formatQty = (n, decimals = 3) => {
  if (n == null || n === '') return '—';
  return (parseFloat(n) || 0).toLocaleString('es-PE', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
};

export const formatPct = (n) => {
  if (n == null || n === '') return '—';
  return `${Number(n).toFixed(1)}%`;
};

export const formatShortDate = (isoDate) => {
  if (!isoDate) return '—';
  const [y, m, d] = String(isoDate).split('-').map(Number);
  if (!y || !m || !d) return isoDate;
  const months = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  return `${d} ${months[m - 1] ?? m} ${y}`;
};
